export default "__VITE_ASSET__TcPOkJYl__"